/** Registers name a site by its operating area, "EOA" for the Eastern one. */
const REGION_LABELS: Record<string, string> = {
  eoa: "Eastern Region",
  coa: "Central Region",
  soa: "Southern Region",
  woa: "Western Region",
};

/** Operating areas of the fleet, offered by the header even before one is assessed. */
export const OPERATING_AREAS = ["EOA", "COA", "SOA", "WOA"];

/** Operating areas not covered by the assessment yet, shown greyed out. */
export const UNCOVERED_OPERATING_AREAS = ["SOA", "WOA"];

export function regionLabel(region: string): string {
  return REGION_LABELS[region.trim().toLowerCase()] ?? region;
}
